import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
  ERROR = '';
  reserve: boolean;
  constructor(
    private modalController: ModalController,
    private SS: SubjectService,
    private translate: TranslateService,
    private route: Router,
    private UTS: UtilitiesService
  ) {
    this.SS.addonBuyError.subscribe((r: any) => {
      if (r) {
        this.reserve = false;
        this.ERROR = r;
        if (
          this.ERROR == 'null' ||
          this.ERROR == null ||
          this.ERROR == 'ERROR_RTF_VAL-00005' ||
          this.ERROR == 'ERROR_RTF_VAL-00007' ||
          this.ERROR == 'ERROR_RTF_COMS-00001'
        ) {
          this.translate.get(['SORRY_ERROR']).subscribe((m) => {
            this.ERROR = m['SORRY_ERROR'];
          });
        }
      }
    });
  }

  ngOnInit() {}

  ok() {
    this.dismiss();
  }

  cancel() {
    this.dismiss();
  }

  closePopUpEN() {
    this.dismiss();
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }
  backToAddons(){
    this.modalController.dismiss();
  }
}
